/// <reference path="../../node_modules/@types/jquery/index.d.ts" />
import { netDaniaThemes } from './net-dania-themes'
import { initGraph } from './js/init-graph'
// @ts-expect-error
window.NetDaniaThemes = netDaniaThemes

jQuery(initGraph)
